import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("cashsales") !== null && localStorage.getItem("cashsales") !== undefined && localStorage.getItem("cashsales") !== "") {

    data = JSON.parse(localStorage.getItem("cashsales"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getcashsales: (state, action) => {
            localStorage.setItem("cashsales", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const {getcashsales } = Insider.actions;
export default Insider.reducer;